import { SearchOutlined } from '@ant-design/icons';
import { Button, Form, Input, Row, Select, Space } from 'antd';
import React, { ReactElement, useEffect } from 'react';
import { stringTrim } from '../../utils/StringUtils';
import styles from "./diseaseSetPage.module.css";

interface queryProps {
  onSubmit: (obj: any) => void
}

export const Query = ({
  onSubmit
}: queryProps): ReactElement => {

  const [form] = Form.useForm()

  useEffect(() => {
    form.submit()
  }, [])
  return (
    <div>
      {/* 筛选查询区域 */}
      <Form
        form={form}
        autoComplete='off'
        initialValues={{
          customFlag: 0,
          status: 2,
          listType: 1,
        }}
        onFinish={(values) => {
          onSubmit(values)
        }}
      >
        <Row
          justify='space-between'
          align='middle'
          className={styles.queryWrap}
        >
          <Space>
            <Form.Item name='param' noStyle getValueFromEvent={stringTrim}>
              <Input
                allowClear
                placeholder='请输入疾病名称/助记码/ICD10编码'
                prefix={<SearchOutlined />}
                style={{ width: '315px' }}
                onChange={form.submit}
              />
            </Form.Item>

            <Form.Item noStyle name='status'>
              <Select
                style={{ width: '10rem' }}
                placeholder='状态'
                onChange={form.submit}
                allowClear
              >
                <Select.Option value={2}>状态-启用</Select.Option>
                <Select.Option value={1}>状态-禁用</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item noStyle name='listType'>
              <Select
                style={{ width: '15rem' }}
                placeholder='目录类别'
                onChange={form.submit}
              >
                <Select.Option value={0}>目录类别-医保目录</Select.Option>
                <Select.Option value={1}>目录类别-自费目录</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item noStyle name='customFlag'>
              <Select
                style={{ width: '15rem' }}
                placeholder='数据来源'
                onChange={form.submit}
              >
                <Select.Option value={0}>数据来源-系统录入</Select.Option>
                {/* <Select.Option value={1}>数据来源-手工录入</Select.Option> */}
              </Select>
            </Form.Item>
          </Space>
          <Button type='primary' htmlType='submit'>
            查询
          </Button>
        </Row>
      </Form>
    </div>
  );
}

